import React from 'react'
import { all_routes } from '../../router/all_routes'
import { Link } from 'react-router-dom'
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from '../../../core/common/datePicker';
import { activityDetails } from '../../../core/data/json/activityDetails';
import CrmsModal from '../../../core/modals/crms_modal';
import CollapseHeader from '../../../core/common/collapse-header/collapse-header';

const Activity = () => {

    const data = activityDetails;
 
    const columns = [
        {
            title: "APMC Name",
            dataIndex: "apmc_name",
            render: (text: string) => <p className="fs-14 text-dark fw-medium">{text}</p>,
            sorter: (a: any, b: any) => a.apmc_name.length - b.apmc_name.length,
        },
        {
            title: "Email",
            dataIndex: "email",
            render: (text: string) => <p className="fs-14 text-dark fw-medium">{text}</p>,
            sorter: (a: any, b: any) => a.email.length - b.email.length,
        },
        {
            title: "Phone Number",
            dataIndex: "phone_number",
            sorter: (a: any, b: any) => a.phone_number.length - b.phone_number.length,
        },
        {
            title: "Commodities",
            dataIndex: "commodities",
            render: (commodities: string[]) => (
                <span className="badge badge-info-transparent">
                    {commodities.join(", ")}
                </span>
            ),
            sorter: (a: any, b: any) => a.commodities.length - b.commodities.length,
        },
        {
            title: "Address (Street)",
            dataIndex: "address",
            sorter: (a: any, b: any) => a.address.length - b.address.length,
        },
        {
            title: "Pincode",
            dataIndex: "pincode",
            sorter: (a: any, b: any) => a.pincode.length - b.pincode.length,
        },
        {
            title: "State",
            dataIndex: "state",
            sorter: (a: any, b: any) => a.state.length - b.state.length,
        },
        {
            title: "District",
            dataIndex: "district",
            sorter: (a: any, b: any) => a.district.length - b.district.length,
        },
        {
            title: "City/Village",
            dataIndex: "city_village",
            sorter: (a: any, b: any) => a.city_village.length - b.city_village.length,
        },
        {
            title: "Post",
            dataIndex: "post",
            sorter: (a: any, b: any) => a.post.length - b.post.length,
        },
        {
            title: "License No.",
            dataIndex: "license_no",
            sorter: (a: any, b: any) => a.license_no.length - b.license_no.length,
        },
        {
            title: "Documents",
            dataIndex: "documents",
            render: (docs: string[]) => (
                <div className="d-flex flex-wrap">
                    {docs.map((doc, index) => (
                        <a key={index} href={doc} target="_blank" rel="noopener noreferrer" className="me-2">
                            <i className="ti ti-file" /> Document {index + 1}
                        </a>
                    ))}
                </div>
            ),
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: () => (
                <div className="action-icon d-inline-flex">
                    <Link
                        to="#"
                        className="me-2"
                        data-bs-toggle="modal"
                        data-inert={true}
                        data-bs-target="#edit_activity"
                    >
                        <i className="ti ti-edit" />
                    </Link>
                    <Link
                        to="#"
                        data-bs-toggle="modal"
                        data-inert={true}
                        data-bs-target="#delete_modal"
                    >
                        <i className="ti ti-trash" />
                    </Link>
                </div>
            ),
        },
    ];


    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">APMC</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                      
                                    </li>
                                    <li className="breadcrumb-item">CRM</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        APMC List
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="me-2 mb-2">
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="ti ti-file-export me-1" />
                                        Export
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-pdf me-1" />
                                                Export as PDF
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-xls me-1" />
                                                Export as Excel{" "}
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="mb-2">
                                <Link
                                    to="#"
                                    data-bs-toggle="modal" data-inert={true}
                                    data-bs-target="#add_activity"
                                    className="btn btn-primary d-flex align-items-center"
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add APMC
                                </Link>
                            </div>
                            <div className="ms-2 head-icons">
                            <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    {/* Leads List */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Activity List</h5>
                            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                                <div className="me-3">
                                    <div className="input-icon-end position-relative">
                                        <PredefinedDateRanges />
                                        <span className="input-icon-addon">
                                            <i className="ti ti-chevron-down" />
                                        </span>
                                    </div>
                                </div>
                                <div className="dropdown me-3">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        Activity Type
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Meeting
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Calls
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Tasks
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Email
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        Sort By : Last 7 Days
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Recently Added
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Ascending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Desending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Last Month
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                            >
                                                Last 7 Days
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <Table dataSource={data} columns={columns} Selection={true} />
                        </div>
                    </div>
                    {/* /Leads List */}
                </div>
            
            </div>
            {/* /Page Wrapper */}
            <CrmsModal/>
        </>
       

    )
}

export default Activity
